import { css } from 'styled-components'
import { colors } from 'client/styles'

export const fullWidth = css`
  width: 100%;
  text-align: center;
  justify-content: center;
`

export const bigSizeStyle = css`
  font-size: 16px;
  line-height: 1.25;
  padding-block: 12px;
  padding-inline: 20px;
`

export const smallSizeStyle = css`
  height: 32px;
  padding-block: 12px;
  padding-inline: 8px;
  font-size: 14px;
`

export const primaryStyle = css`
  background: ${colors.magenta};
  border: 2px solid ${colors.magenta};
  color: ${colors.white};

  svg {
    fill: ${colors.white};
  }

  :hover,
  :active,
  :focus {
    background: ${colors.magenta3};
    outline: none;
    border: 2px solid ${colors.magenta3};
    cursor: pointer;
    text-decoration: none;
  }

  a {
    color: ${colors.white};
  }
`

export const secondaryStyle = css`
  background: ${colors.white};
  border: 2px solid ${colors.magenta};
  color: ${colors.magenta};

  svg {
    fill: ${colors.magenta};
  }

  :hover,
  :active,
  :focus {
    background: ${colors.magenta};
    border: 2px solid ${colors.magenta};
    color: ${colors.white};
    cursor: pointer;
    text-decoration: none;

    svg {
      fill: ${colors.white};
    }
  }

  a {
    color: ${colors.magenta};
  }
`

export const tertiaryStyle = css`
  background: ${colors.white};
  border: 2px solid ${colors.grey1};
  color: ${colors.grey1};

  svg {
    fill: ${colors.grey1};
  }

  :hover,
  :active,
  :focus {
    background: ${colors.grey5};
    outline: none;
    cursor: pointer;
    text-decoration: none;
  }

  a {
    color: ${colors.grey1};
  }
`

export const primeStyle = css`
  background: ${colors.purple2};
  border: 2px solid ${colors.purple2};
  color: ${colors.white};

  svg {
    fill: ${colors.purple2};
  }

  :hover,
  :active,
  :focus {
    background: ${colors.purple3};
    outline: none;
    cursor: pointer;
    text-decoration: none;
  }

  a {
    color: ${colors.white};
  }
`

export const disabledStyle = css`
  border: 2px solid ${colors.grey4};
  background: ${colors.grey4};

  cursor: not-allowed;
  pointer-events: none;

  svg {
    fill: ${colors.grey3};
  }

  :hover,
  :active,
  :focus {
    border: 2px solid ${colors.grey4};
    background: ${colors.grey4};
    outline: none;
    cursor: pointer;
    text-decoration: none;
  }

  a {
    color: ${colors.grey3};
  }
`
